/* eslint-disable */

import moment from 'moment';
import { constants } from "../constants/index";
import { enums } from "../enums";
import { combineReducers } from 'redux'
import uploadAssetMeteringReducer from "./Maintenance/uploadAssetMeteringReducer";

const INITIAL_STATE = {
  organizationForMonthlyReportId: null,
  startMonthForMonthlyReport: moment().subtract(1, 'month').format('M'),
  endMonthForMonthlyReport: moment().subtract(1, 'month').format('M'),
  startYearForMonthlyReport: moment().subtract(1, 'month').format('YYYY'),
  endYearForMonthlyReport: moment().subtract(1, 'month').format('YYYY'),
  destinationForMonthlyReport: 'local',
  loadingGenerateMonthlyReportAction: false,
  selectedTab: 0,
  showDateFilter: false,
  demoDataFormOpen: false,
  demoDataDeleteWarningOpen: false,
  loadingList: false,
  loadingLog: false,
  loadingLogList: false,
  loadingMaintenanceAction: false,
  loading: false,
  loadingBalance: false,
  selectedOrganizationBalanceAccount: null,
  demoDataList: [],
  logList: [],
  demoData: {
    assetID: "",
    production_type: enums.ConsumptionTypes.CONSUMPTION,
    energy: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    dates:"[]"
  },
  startDate: null,
  endDate: null,
  loadingExportProdData: false,
  exportProdStartDate: null,
  exportProdEndDate: null,
  dialogStartDateOpen: false,
  dialogEndDateOpen: false,
  dialogWarningOpen: false,
  organizationId: null,
  reportOrganizationId: null,
  reportUnit: 'MWh',
  actionId: enums.MaintenanceActionTypes.MATCHING_LIVE,
  localDataset: null,
  loadingDataset: false,
  comment:""
};

const maintenanceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_TAB":
      return {
        ...state,
        selectedTab: action.payload
      };

    case "DATASET_CHANGED":
      return {
        ...state,
        localDataset: action.payload
      };

    case "UPLOAD_DATASET_START":
      return {
        ...state,
        loadingDataset: true
      };

    case "UPLOAD_DATASET_SUCCESS":
      return {
        ...state,
        loadingDataset: false
      };

    case "UPLOAD_DATASET_FAIL":
      return {
        ...state,
        loadingDataset: false
      };

    case 'DEMO_DATA_ENERGY_DATA_CHANGED':
      let newDemoDataEnergy = { ...state.demoData,  energy: JSON.parse(action.payload) }
      return { ...state,  demoData: newDemoDataEnergy }

    case 'DEMO_DATA_ASSET_ID_CHANGED':
      let newDemoDataAssetId = { ...state.demoData,  assetID: action.payload }
      return { ...state,  demoData: newDemoDataAssetId }

    case 'DEMO_DATA_TYPE_CHANGED':
      let newDemoDataType = { ...state.demoData,  production_type: action.payload }
      return { ...state,  demoData: newDemoDataType }

    case 'CREATE_DEMO_DATA_START':
      return { ...state,  loading: true }

    case 'CREATE_DEMO_DATA_SUCCESS':
      return { ...state,  loading: false }      

    case 'CREATE_DEMO_DATA_FAIL':
      return { ...state,  loading: false }     

    case 'GET_DEMO_DATA_LIST_START':
        return { ...state, loadingList: true }
    
    case 'GET_DEMO_DATA_LIST_SUCCESS':
      return {
        ...state,
        demoDataList: action.payload,
        loadingList: false
      }
  
    case 'GET_DEMO_DATA_LIST_FAIL':
      return { ...state, loadingList: false }
    
    case 'GET_DEMO_DATA_START':
        return { ...state, loading: true }
    
    case 'GET_DEMO_DATA_SUCCESS':
      return {
        ...state,
        demoData: action.payload,
        loading: false
      }
  
    case 'GET_DEMO_DATA_FAIL':
      return { ...state, loading: false }
      
    case 'CREATE_LOG_START':
      return { ...state,  loading: true }

    case 'CREATE_LOG_SUCCESS':
      return { ...state,  loading: false }      

    case 'CREATE_LOG_FAIL':
      return { ...state,  loading: false }     

    case 'GET_LOG_LIST_START':
        return { ...state, loadingLogList: true }

    case 'GET_LOG_LIST_SUCCESS':
      return {
        ...state,
        logList: action.payload,
        loadingLogList: false
      }

    case 'GET_LOG_LIST_FAIL':
      return { ...state, loadingLogList: false }


    case 'GET_LOG_START':
      return { ...state, loadingLog: true }

    case 'GET_LOG_SUCCESS':
      return {
        ...state,
        log: action.payload,
        loadingLog: false
      }

    case 'GET_LOG_FAIL':
      return { ...state, loadingLog: false }

    case 'OPEN_DEMO_DATA_DELETE_WARNING_DIALOG':
      return { ...state, demoDataDeleteWarningOpen: true }

    case 'CLOSE_DEMO_DATA_DELETE_WARNING_DIALOG':
      return { ...state, demoDataDeleteWarningOpen: false }

    case 'TOGGLE_DEMO_DATA_DELETE_WARNING_DIALOG':
      let newDemoDataDeleteWarningOpen = !this.state.demoDataDeleteWarningOpen
      return { ...state, demoDataDeleteWarningOpen: newDemoDataDeleteWarningOpen }

    case 'OPEN_DEMO_DATA_FORM_DIALOG':
      return { ...state, demoDataFormOpen: true }

    case 'CLOSE_DEMO_DATA_FORM_DIALOG':
      return { ...state, demoDataFormOpen: false }

    case 'TOGGLE_DEMO_DATA_FORM_DIALOG':
      let newDemoDataFormOpen = !this.state.demoDataFormOpen
      return { ...state, demoDataFormOpen: newDemoDataFormOpen }

    case 'RESET_DEMO_DATA':
        return { ...state, demoData: INITIAL_STATE.demoData}

    case 'MAINTENANCE_MATCHING_ORGANIZATION_CHANGED':
        return { ...state,  organizationId: action.payload }

    case 'MAINTENANCE_GENERATE_PDF_REPORT_ORGANIZATION_CHANGED':
        return { ...state,  organizationForMonthlyReportId: action.payload }

    case 'MAINTENANCE_GENERATE_PDF_REPORT_START_MONTH_CHANGED':
      return { ...state,  startMonthForMonthlyReport: action.payload }

    case 'MAINTENANCE_GENERATE_PDF_REPORT_START_YEAR_CHANGED':
      return { ...state,  startYearForMonthlyReport: action.payload }

    case 'MAINTENANCE_GENERATE_PDF_REPORT_END_MONTH_CHANGED':
      return { ...state,  endMonthForMonthlyReport: action.payload }

    case 'MAINTENANCE_GENERATE_PDF_REPORT_END_YEAR_CHANGED':
      return { ...state,  endYearForMonthlyReport: action.payload }

    case 'MAINTENANCE_GENERATE_PDF_REPORT_DESTINATION_CHANGED':
      return { ...state,  destinationForMonthlyReport: action.payload }

    case "REPORT_UNIT_CHANGED":
      return {
        ...state,
        reportUnit: action.payload
      };

    case 'REPORT_ORGANIZATION_CHANGED':
        return { ...state,  reportOrganizationId: action.payload }

    case 'MAINTENANCE_ACTION_CHANGED':
       return { ...state,  actionId: action.payload }

    case 'MAINTENANCE_COMMENT_CHANGED':
      return { ...state,  comment: action.payload }

    case 'TOGGLE_MAINTENANCE_STARTDATE':
      const dialogStartDateOpen = !state.dialogStartDateOpen;
      return { ...state, dialogStartDateOpen }

    case 'TOGGLE_MAINTENANCE_ENDDATE':
      const dialogEndDateOpen = !state.dialogEndDateOpen;
      return { ...state, dialogEndDateOpen }

    case 'TOGGLE_MAINTENANCE_WARNING':
      const dialogWarningOpen = !state.dialogWarningOpen;
      return { ...state, dialogWarningOpen }

    case 'SET_MAINTENANCE_STARTDATE':
      const startDate = action.payload;
      return { ...state, startDate }

    case 'SET_MAINTENANCE_ENDDATE':
      const endDate = action.payload;
      return { ...state, endDate }
    
    case 'SET_LOADING_EXPORT_PROD_DATA':
      const loadingExportProdData = action.payload;
      return { ...state, loadingExportProdData }

    case 'SET_EXPORT_PROD_STARTDATE':
      const exportProdStartDate = action.payload;
      return { ...state, exportProdStartDate }

    case 'SET_EXPORT_PROD_ENDDATE':
      const exportProdEndDate = action.payload;
      return { ...state, exportProdEndDate }
    
    case 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_START':
        return { ...state, loadingBalance: true }       
  
    case 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_SUCCESS':
      return { ...state, loadingBalance: false, selectedOrganizationBalanceAccount: action.payload }
    
    case 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_FAIL':
        return { ...state, loadingBalance: false } 
          
    case 'MAINTENANCE_ACTION_START':
      return { ...state, loadingMaintenanceAction: true }       

    case 'MAINTENANCE_ACTION_END':
      return { ...state, loadingMaintenanceAction: false }
          
    case 'MAINTENANCE_PDF_CERTIFICATES_GENERATION_ACTION_START':
      return { ...state, loadingGenerateMonthlyReportAction: true }       

    case 'MAINTENANCE_PDF_CERTIFICATES_GENERATION_ACTION_END':
      return { ...state, loadingGenerateMonthlyReportAction: false }

    case 'GET_ORGANIZATIONS_SUCCESS':
      let organizationsForMonthlyReport = action.payload.filter(org => org.generateMonthlyPdfCertificateReport)
      let defaultOrganizationForMonthlyReportId = organizationsForMonthlyReport && organizationsForMonthlyReport[0] ? organizationsForMonthlyReport[0]._id : null
      return { ...state,  organizationId: null, reportOrganizationId: null, organizationForMonthlyReportId: defaultOrganizationForMonthlyReportId}

    default:
      return state
  }
}

export default maintenanceReducer;



// WEBPACK FOOTER //
// ./src/reducers/maintenanceReducer.js